import React from 'react'

const ResizeControl = props => {
  const onMouseDownTop = event => {
    props.onMouseDown(event, 'rs_top')
  }
  const onMouseDownBottom = event => {
    props.onMouseDown(event, 'rs_bot')
  }
  const onMouseDownLeft = event => {
    props.onMouseDown(event, 'rs_left')
  }
  const onMouseDownRight = event => {
    props.onMouseDown(event, 'rs_right')
  }
  const onMouseDownTopRight = event => {
    props.onMouseDown(event, 'rs_topright')
  }
  const onMouseDownTopLeft = event => {
    props.onMouseDown(event, 'rs_topleft')
  }
  const onMouseDownBottomRight = event => {
    props.onMouseDown(event, 'rs_bottomright')
  }
  const onMouseDownBottomLeft = event => {
    props.onMouseDown(event, 'rs_bottomleft')
  }
  return (
    <React.Fragment>
      <div className="ap-barcode-rrd-control__resize-top" onMouseDown={onMouseDownTop} />
      <div className="ap-barcode-rrd-control__resize-bottom" onMouseDown={onMouseDownBottom} />
      <div className="ap-barcode-rrd-control__resize-left" onMouseDown={onMouseDownLeft} />
      <div className="ap-barcode-rrd-control__resize-right" onMouseDown={onMouseDownRight} />
      <div className="ap-barcode-rrd-control__resize-top-right" onMouseDown={onMouseDownTopRight} />
      <div className="ap-barcode-rrd-control__resize-top-left" onMouseDown={onMouseDownTopLeft} />
      <div
        className="ap-barcode-rrd-control__resize-bottom-right"
        onMouseDown={onMouseDownBottomRight}
      />
      <div
        className="ap-barcode-rrd-control__resize-bottom-left"
        onMouseDown={onMouseDownBottomLeft}
      />
    </React.Fragment>
  )
}

export default ResizeControl
